


import { Inistitution } from "./institution";
import { VideoLessionProgram } from "../schoolPrograms/videoLessionProgram/videoLessionProgram";


export const SchoolVideoLessionFile = () => {

    return (<>
        <Inistitution>
            <VideoLessionProgram isAddFilesVisible={false} isDeleteFilesVisible={false} />

        </Inistitution>
    </>);
}